module.exports = __webpack_public_path__ + "static/media/Bell_beaker_mba_england_200px.b99a928f.png";